var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.496 3.68311H16.505C18.987 3.68311 21 5.69511 21 8.17911V17.1881C21 19.6701 18.988 21.6831 16.504 21.6831H7.496C5.013 21.6831 3 19.6711 3 17.1871V8.17911C3 5.69611 5.012 3.68311 7.496 3.68311V3.68311Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9487 7.39614C16.7627 7.39714 16.6117 7.54814 16.6117 7.73414C16.6117 7.92014 16.7637 8.07114 16.9497 8.07114C17.1357 8.07114 17.2867 7.92014 17.2867 7.73414C17.2877 7.54714 17.1357 7.39614 16.9487 7.39614",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.546 10.1374C15.9519 11.5433 15.9519 13.8227 14.546 15.2286C13.1401 16.6345 10.8607 16.6345 9.45481 15.2286C8.04892 13.8227 8.04892 11.5433 9.45481 10.1374C10.8607 8.73154 13.1401 8.73154 14.546 10.1374",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8a4cc0394f54a1e500c468b5435838df.svg";
export { ForwardRef as ReactComponent };